import img1 from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/authors/1.png'
import img2 from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/authors/2.png'
import img3 from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/authors/3.png'
import img4 from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/authors/4.png'
import img5 from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/authors/5.png'
import img6 from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/authors/6.png'
import img7 from 'client/bookmate/pages/originals/assets/el-corazon-de-ls-bestia/authors/7.png'

export const authorList: {
  name: string
  date?: string
  description: string
  image: string
}[] = [
  {
    name: 'Leila Guerriero',
    date: '(Junín, 1967)',
    image: img1,
    description:
      'Periodista, escritora y editora. Su obra ha sido traducida a más de diez idiomas, y recientemente ganó el Premio Zenda de Narrativa 2023-2024 por su libro La llamada.',
  },
  {
    name: 'Martín Caparrós',
    date: '(Buenos Aires, 1957)',
    image: img2,
    description:
      'Historiador, escritor y periodista. Tradujo a Voltaire, a Shakespeare y a Quevedo, recibió los premios Planeta y Herralde de novela, entre otros.',
  },
  {
    name: 'Santiago Rosero',
    date: '(Quito, 1978)',
    image: img3,
    description:
      'Periodista y cocinero. Su libro El fotógrafo de las tinieblas y otras crónicas de París (La caída, 2018) recibió el premio José Peralta a la mejor obra periodística del Ecuador.',
  },
  {
    name: 'Emiliano Ruiz Parra',
    date: '(Ciudad de México, 1982)',
    image: img4,
    description:
      'Escritor y periodista. Entre 2020 y 2024 dirigió la Unidad de Investigaciones Periodísticas de la UNAM.',
  },
  {
    name: 'Soledad Gago',
    date: '(Melo, 1993)',
    image: img5,
    description:
      'Periodista. Trabaja en el diario El País, de Montevideo, desde 2014. Ha publicado varios libros y recientemente produjo y guionó el podcast “Andes, 72 días en la montaña”.',
  },
  {
    name: 'Lina Vargas Fonseca',
    date: '(Bogotá, 1985)',
    image: img6,
    description:
      'Periodista y literata. En la actualidad es periodista del medio digital colombiano Cerosetenta y del podcast Womansplaining.',
  },
  {
    name: 'Sabine Drysdale',
    date: '(Santiago de Chile, 1976)',
    image: img7,
    description:
      'Periodista. Su perfil de Violeta Parra fue incluido en el libro Extremas (Ediciones UDP, 2019) y en la antología noruega Crónica (Camino, 2023).',
  },
]
